import React, { useContext } from 'react';
import AppointmentCell from './AppointmentCell';
import { getHour, getMinute } from '../../../utils/dateTimeUtil';
import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../../contexts/languageContext';
const styles = makeStyles({
    rtlColumn: {
        width: '14%',
        height: 'calc(108 * 24px)',
        borderLeft: '1px dashed #d8d8d8',
        '&:last-child': {
            borderLeft: 'none'
        }
    },
    ltrColumn: {
        width: '14%',
        height: 'calc(108 * 24px)',
        borderLeft: '1px dashed #d8d8d8',
        '&:first-child': {
            borderLeft: 'none'
        }
    }
});
function AppointmentColumn(props) {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const hours = Array(24);
    for (let i = 0; i < 24; i++) {
        hours.push(i);
    }
    return (
        <div className={lang === 'fa' ? classes.rtlColumn : classes.ltrColumn}>
            {hours.map((hour, index) => (
                <AppointmentCell
                    appointments={props?.appointments
                        ?.filter((val) => +getHour(val.appointed) === hour)
                        ?.sort((a, b) => getMinute(a?.appointed) - getMinute(b?.appointed))}
                    key={index}
                    hour={hour}
                    date={props.date}
                />
            ))}
        </div>
    );
}
AppointmentColumn.propTypes = {
    appointments: PropTypes.arrayOf(PropTypes.object),
    date: PropTypes.string
};
export default AppointmentColumn;
